export const API_REQUEST_STATES = {
  REQUEST: "REQUEST",
  FULFILLED: "FULFILLED",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
};
